import { AppEventsCapability, Specs } from '@doxyme/extensions-bridge';
import { useCapability } from '@doxyme/extensions-bridge-react';
import { bridge } from '../../../features/extensions/instances';

type BaseAppsEventParam = {
  sessionId: string;
};

type SessionEndedParams = BaseAppsEventParam & {
  sessionWasOnHold?: boolean;
};

export type UseExtensionsAppEventsReturnValue = {
  sendProviderJoined: (params: BaseAppsEventParam) => void;
  sendProviderLeft: (params: BaseAppsEventParam) => void;
  sendSessionEnded: (params: SessionEndedParams) => void;
};

export function useExtensionsAppEvents(): UseExtensionsAppEventsReturnValue {
  const appEvents = useCapability<AppEventsCapability>(
    bridge,
    AppEventsCapability.id,
  );

  const sendProviderJoined = ({ sessionId }: BaseAppsEventParam) => {
    appEvents?.send(Specs.AppEvents.Events.ProviderJoined, { sessionId });
  };

  const sendProviderLeft = ({ sessionId }: BaseAppsEventParam) => {
    appEvents?.send(Specs.AppEvents.Events.ProviderLeft, { sessionId });
  };

  const sendSessionEnded = ({
    sessionId,
    sessionWasOnHold = false,
  }: SessionEndedParams) => {
    appEvents?.send(Specs.AppEvents.Events.SessionEnded, {
      sessionId,
      sessionWasOnHold,
    });
  };

  return {
    sendProviderJoined,
    sendProviderLeft,
    sendSessionEnded,
  };
}
